module.exports = __webpack_public_path__ + "img/mobile011.e376c4b0.png";